// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtCardActivationResultModel } from './extCardActivationResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CardV1CardV1ActivateCardDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': Array<ExtCardActivationResultModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CardV1CardV1ActivateCardDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<ExtCardActivationResultModel>"
        },
    ];

    static getAttributeTypeMap() {
        return CardV1CardV1ActivateCardDefaultResponse.attributeTypeMap;
    }
}
